// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a1f0c11","239":"2d58cc19","455":"fc5f7243"}[chunkId] + ".chunk.js";
};